require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-bootstrap-add-id-attributes-to-bootstrap-elements.json") })
        }
      }, "path---front-end-libraries-bootstrap-add-id-attributes-to-bootstrap-elements");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-bootstrap-add-id-attributes-to-bootstrap-elements!./.cache/json/front-end-libraries-bootstrap-add-id-attributes-to-bootstrap-elements.json
// module id = 1989
// module chunks = 231608221292675